<template>
  <div class="private-list-wrapper">
    <div class="private-search">
      <form @submit.prevent="searchPrivate" action="" class="search-box">
        <icon icon-class="search"></icon>
        <input type="search" ref="searchInput" placeholder="请搜索方名或功能主治" v-model="searchKey" name="" id="">
        <icon icon-class="close" class="clear" @click.native="clearSearch" v-show="searchKey"></icon>
      </form>
    </div>
    <div class="prescription-list" ref="expList" @scroll="scrollToLoad">
      <div class="prescription-item" v-for="item in scriptList" :key="item.id" @click="chooseScript(item)">
        <div class="item-head">
          <div class="item-title">{{item.pres_title}}</div>
        </div>
        <div class="prescription-card-content">{{item.indications}}</div>
        <div class="prescription-card-content">{{item.matters}}</div>
      </div>
      <div class="data-loading" v-if="!expListIsOver">
        <van-loading type="spinner" size="14px">加载中...</van-loading>
      </div>
      <div class="data-finish" v-if="expListIsOver">无更多数据</div>
    </div>
    <!--详情-->
    <van-popup v-model="detailScriptPickShow" position="bottom" :style="{height: '100%'}">
      <div class="popup-wrapper">
        <div class="popup-top">
          <div class="popup-header">
            <span class="left-control" @click="detailScriptPickShow = false">取消</span>
            {{privateData.pres_title}}
            <span v-if="context" class="right-control" @click="selectScript">使用</span>
          </div>

        </div>

        <div class="data-wrapper prescription-wrapper">
          <!-- 经方模板列表 -->
          <div class="prescription-list">
            <div class="prescription-item">
              <div class="item-head">
                <div class="item-title item-title-mini">提供者</div>
              </div>
              <div class="prescription-card-content">{{privateData.pres_name}}</div>
              <div class="item-head">
                <div class="item-title item-title-mini">提供者简介</div>
              </div>
              <div class="prescription-card-content">
                <div :key="index" v-for="(item, index) in content">
                  <p v-if="item.row_type=='txt'">
                    {{item.row_content}}
                  </p>
                  <p v-else>
                    <img class="content-img" :src='item.row_content' />
                  </p>
                </div>
              </div>
              <div class="item-head">
                <div class="item-title item-title-mini">主治与功效</div>
              </div>
              <div class="prescription-card-content">{{privateData.indications}}</div>
              <div class="item-head">
                <div class="item-title item-title-mini">不良反应</div>
              </div>
              <div class="prescription-card-content">{{privateData.untoward_reaction}}</div>
              <div class="item-head">
                <div class="item-title item-title-mini">注意事项</div>
              </div>
              <div class="prescription-card-content">{{privateData.matters}}</div>
              <div class="item-head">
                <div class="item-title item-title-mini">用法用量</div>
              </div>
              <div class="prescription-card-content">{{usingString}}</div>
              <div class="item-head">
                <div class="item-title item-title-mini">零售价</div>
              </div>
              <div class="prescription-card-content">￥{{privateData.price/100}}元</div>
              <div class="item-head">
                <div class="item-title item-title-mini">药材成分</div>
              </div>
              <div class="prescription-card-content">{{privateData.drug_summ}}</div>
            </div>


          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<style lang="less" scoped>
  .data-wrapper{
    padding-top: 0px;

  }
  .prescription-wrapper{
    padding-top: 48px;
    height: calc(100%);
    background: #FAFAFA;
    overflow-y: auto;
    -webkit-overflow-scroll: touch;

 }
  .popup-wrapper{
    position: relative;
    width: 100%;
    height: 100%;
    background: #FFF;
    .popup-top{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 50px;
      font-size: 15px;
      font-weight: bold;
      background: #F3F3F3;
      z-index: 100;
      .popup-header{
        position: relative;
        top: 0;
        left: 0;
        width: 100%;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 15px;
        font-weight: bold;
        background: #F3F3F3;
        z-index: 90;
        .close-popup{
          position: absolute;
          top: 50%;
          right: 16px;
          transform: translateY(-50%);
          font-size: 13px;
          color: @black;
          font-weight: normal;
          background: transparent;
          border: 0;
        }
        .left-control{
          position: absolute;
          top: 50%;
          left: 16px;
          transform: translateY(-50%);
          font-size: 15px;
          color: @black;
          font-weight: normal;
          background: transparent;
          border: 0;

          padding:3px 10px;
          line-height: 20px;


        }
        .right-control{
          position: absolute;
          top: 55%;
          right: 16px;
          transform: translateY(-50%);
          font-size: 15px;
          color:@xile;
          font-weight: normal;
          background: transparent;
          border: solid 1px #3668A6;
          border-radius: 3px;
  font-weight: bold;
          border-radius: 3px;
          padding:3px 18px;
          box-shadow: 0px 2px 3px 0px rgba(51,51,51,0.08);

        }
      }
    }

    .prescription-wrapper{
      padding-top: 48px;
      height: calc(100%);
      background: #FAFAFA;
      overflow-y: auto;
      -webkit-overflow-scroll: touch;
      .prescription-list{
        padding: 0 16px 16px;
        .prescription-item{
          margin-top: 12px;
          width: 100%;
          border-radius: 6px;
          overflow-y: hidden;
          box-shadow: 0px 2px 10px 0px rgba(51,51,51,0.08);
          border: 1px solid transparent;
          background: #FFF;
          &.selected{
            border-color: @xile;
          }
          .item-head{
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 48px;
            border-bottom: 1px solid #F3F3F3;
            padding: 0 10px;
            background: #FAFAFA;

            .item-title{
              position: relative;
              padding-left: 19px;
              font-size: 14px;
              line-height: 16px;
              font-weight: bold;
              color: @black;
              &::after{
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                width: 4px;
                height: 16px;
                background: @xile;
                border-radius: 2px;
              }
            }
            .sub-title{
              max-width: 170px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 14px;
              color: @black;
            }
          }
          .prescription-card-content{
            padding: 10px;
            font-size: 14px;
            line-height: 24px;
            color: #666;

            .content-img{
              width:100%;
              margin:5px auto;
              display: block;
            }
          }
        }
      }
    }
  }
  .private-list-wrapper{
    min-height: 100vh;
    background: #FAFAFA;
    .list-loading{
      padding-top: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .private-search{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 50px;
      border-bottom: 1px solid #F2F0EC;
      padding: 10px 16px;
      background: #FFF;
      z-index: 10;
      .search-box{
        width: 100%;
        height: 36px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background: #F7F7F7;
        border-radius: 3px;
        overflow: hidden;
        svg{
          font-size: 16px;
          color: #CCC;
          margin-left: 13px;
          &.clear{
            color: #999;
            margin-right: 8px;
            font-size: 14px;
          }
        }
        input{
          flex: 1;
          height: 100%;
          background: #F7F7F7;
          font-size: 14px;
          color: @black;
          padding: 0 8px;
          &[type=search]::-webkit-search-cancel-button{
            -webkit-appearance: none;
          }
        }
      }
    }
  }
  .prescription-list{

    height: 100%;
    background: #FAFAFA;
    overflow-y: auto;
    -webkit-overflow-scroll: touch;
    padding: 0 16px 16px;
    padding-top: 50px;
    .prescription-item{
      margin-top: 12px;
      width: 100%;
      border-radius: 6px;
      overflow-y: hidden;
      box-shadow: 0px 2px 10px 0px rgba(51,51,51,0.08);
      border: 1px solid transparent;
      background: #FFF;
      &.selected{
        border-color: @xile;
      }
      .item-head{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 48px;
        border-bottom: 1px solid #F3F3F3;
        padding: 0 5px;
        background: #FAFAFA;

        .item-title{
          position: relative;
          padding-left: 19px;
          font-size: 16px;
          line-height: 18px;
          font-weight: bold;
          color: @black;
          &.template{
            max-width: 100%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow-x: hidden;
          }
          &::after{
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 4px;
            height: 16px;
            background: @xile;
            border-radius: 2px;
          }
        }
        .item-title-mini{
          font-size: 14px;
          height: 23px;
        }
        .sub-title{
          max-width: 170px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 14px;
          color: @black;
        }
      }

      .prescription-card-content{
        padding: 10px;
        font-size: 14px;
        line-height: 24px;
        color: #666;
      }
    }
  }
</style>

<script type="text/javascript">
  import xDialog from '@/components/Common/dialog'
  export default {
    data() {
      return {
        searchKey: '',
        // 模板列表
        scriptList: [],
        // 经方模板列表页码
        expScriptPage: 1,
        expListIsOver: false,
        loadTimer: null,
        detailScriptPickShow: false,
        privateData: {},
        context: 0,
        content: []
      }
    },
    components: {
      xDialog,

    },
    computed: {
      scriptInfo() {
        return this.$store.state.prescriptionData || {};
      },
      usingString() {
        let str = '';
        if (this.privateData != null) {
          if (this.privateData.usage == 1) {
            str = '内服、一次' + this.privateData.dosage + '' + this.privateData.unit + '' + '、 一日' + this.privateData.usage_direction +
              '次';
          } else {
            str = '外用、一次' + this.privateData.dosage + '' + this.privateData.unit + '' + '、 一日' + this.privateData.usage_direction +
              '次';
          }
        }
        return str;
      }
    },
    created() {
      this.getPrivateList();
      this.context = this.$route.query.context;
    },
    mounted() {
      window.addEventListener('scroll', this.scrollToLoad);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.scrollToLoad);
    },
    methods: {
      chooseScript(item) {
        // console.log(item)
        this.detailScriptPickShow = true;
        this.privateData = item;
        //console.log(typeof this.privateData.content)
        this.content = JSON.parse(this.privateData.content)

      },
      selectScript() {
        this.scriptInfo.privateData = this.privateData;
        this.$store.commit('setPrescriptionData', this.scriptInfo);
        this.$router.go(-1);
      },
      getPrivateList(type = 'normal', cb) {
        this.$root.post('/getPrivatePretList', {
          count: 30,
          page: this.expScriptPage,
          search: this.searchKey
        }).then(data => {
          console.log(data)
          this.dataDone = true;



          if (data && data.info.length <= 0 && type == 'search' && this.scriptList.length > 0) {
            this.$notify('暂无搜索结果');
          }
          this.expListIsOver = data.is_over == 1 ? true : false;
          if (data && data.info.length > 0) {
            if (type == 'search') {
              this.scriptList = data.info;
            } else {
              this.scriptList = [...this.scriptList, ...data.info];
            }
          }

          if (cb) cb();
        })
      },
      searchPrivate() {
        this.$toast.loading({
          duration: 0,
          loadingType: 'spinner',
          message: '搜索中...'
        })
        this.page = 1;
        this.getPrivateList('search', () => {
          window.scrollTo(0, 0);
          this.$toast.clear();
          this.$refs.searchInput.blur();
        });
      },
      clearSearch() {
        this.searchKey = '';
        window.scrollTo(0, 0);
        this.page = 1;
        this.getPrivateList('search');
      },

      // 经方模板列表滚动加载
      scrollToLoad($event) {
        if (!this.expListIsOver) {
          clearTimeout(this.loadTimer);
          this.loadTimer = setTimeout(() => {
            if (($event.target.offsetHeight + $event.target.scrollTop) == $event.target.scrollHeight) {
              this.expScriptPage++;
              this.getPrivateList();
            }
          }, 200);
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/PrivatePrescription/list.vue